import { makeStyles } from "@material-ui/core";

export const feedbackStyle = makeStyles((theme) => ({
	root: {},
	questionContainer: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		gap: "15px",
		width: "100%",
		maxWidth: "400px",
	},
	questionText: {
		textAlign: "center",
	},
	scaleContainer: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "center",
		alignItems: "center",
		overflowX: "scroll",
		width: "100%",
		cursor: "pointer",
	},
	disabled: {
		pointerEvents: "none",
		opacity: 0.5,
	},
	scaleValue: {
		"display": "flex",
		"flexDirection": "row",
		"justifyContent": "center",
		"alignItems": "center",
		"flex": 1,
		"padding": theme.spacing(1),
		"border": "1px solid #878383",
		"borderLeft": "none",
		"minWidth": "30px",
		"&:first-child": {
			borderRadius: "8px 0 0 8px",
			borderLeft: "1px solid #878383",
		},
		"&:last-child": {
			borderRadius: "0px 8px 8px 0px",
		},
	},
	scaleValueActive: {
		"borderColor": theme.palette.primary.main,
		"& $scaleValueText": {
			color: theme.palette.primary.main,
		},
	},
	scaleValueSelected: {
		"backgroundColor": theme.palette.primary.main,
		"& $scaleValueText": {
			color: "white",
		},
	},
	scaleValueText: {
		fontWeight: "bold",
	},
	scaleTextContainer: {
		display: "flex",
		flexDirection: "row",
		width: "100%",
		margin: "0 auto",
		justifyContent: "space-between",
		alignItems: "center",
		position: "relative",
	},
	star: {
		fontSize: "43px",
		color: "#878383",
		opacity: 0.5,
	},
	starActive: {
		color: theme.palette.primary.main,
		opacity: 1,
	},
	radioContainer: {
		maxWidth: "90%",
	},
	radio: {
		"&.Mui-checked": {
			color: theme.palette.primary.main,
		},
	},
	freeTextContainer: {
		overflow: "visible",
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-end",
		justifyContent: "center",
		gap: "10px",
	},
	freeTextTextArea: {
		minHeight: "100px",
	},
}));
